export const LOAD_PARCELS = 'LOAD_PARCELS';
export const LOAD_PARCELS_PENDING = 'LOAD_PARCELS_PENDING';
export const LOAD_PARCELS_FULFILLED = 'LOAD_PARCELS_FULFILLED';
export const LOAD_PARCELS_REJECTED = 'LOAD_PARCELS_REJECTED';
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
